var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 579.48 492.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0061ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.12,92.59l-145.06,92.6,145.06,92.59L145.06,370.37,0,277l145.06-92.6L0,92.59,145.06,0ZM144.29,399.69,289.35,307.1l145.06,92.59L289.35,492.28ZM290.12,277l145.07-92.6L290.12,92.59,434.41,0,579.48,92.59l-145.07,92.6,145.07,92.59L434.41,370.37Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropboxIcon);
export default __webpack_public_path__ + "static/media/dropbox-icon.8e837199a48dbe5518a215caaa4aae88.svg";
export { ForwardRef as ReactComponent };